"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const react_loops_1 = require("react-loops");
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const lodash_1 = require("lodash");
const utils_1 = require("../../../../utils");
const sortConversionSteps_1 = require("../../utils/sortConversionSteps");
const ConversionStepCanvas_1 = require("../../../ConversionStepCanvas");
const constants_1 = require("../../../../constants");
const reactstrap_1 = require("reactstrap");
const index_1 = require("../../hooks/index");
exports.ConversionCanvasStepsListView = () => {
    const { state: { draft: { steps }, draft, }, } = index_1.useConversionCanvas();
    const { dispatchCanvasAction } = index_1.useConversionCanvasUpdate();
    const sortedSteps = react_1.useMemo(() => sortConversionSteps_1.sortConversionSteps(steps), [steps]);
    const reorder = (sourceOrder, destinationOrder) => {
        let newStepsArr = [...sortedSteps];
        newStepsArr = utils_1.move(newStepsArr, sourceOrder, destinationOrder);
        newStepsArr = newStepsArr.map((s, i) => {
            s.order = i;
            return s;
        });
        dispatchCanvasAction({
            data: {
                draft: Object.assign(Object.assign({}, draft), { steps: sortConversionSteps_1.sortConversionSteps(newStepsArr) }),
            },
            type: 'state',
        });
    };
    return (react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, { onDragEnd: (result) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
            if (result.reason === 'DROP' &&
                result.destination &&
                result.source &&
                lodash_1.isNumber(result.destination.index) &&
                lodash_1.isNumber(result.source.index)) {
                const originalSourceOrder = result.source.index + 0;
                const originalDestinationOrder = result.destination.index + 0;
                reorder(originalSourceOrder, originalDestinationOrder);
            }
        }), onDragStart: () => { } },
        react_1.default.createElement(react_beautiful_dnd_1.Droppable, { droppableId: "conversionSteps" }, provided => (react_1.default.createElement(react_2.OsmosysDiv, { osysName: "ConversionCanvasStepsList.outer", flexRowCenteredFilled: true },
            react_1.default.createElement(react_2.OsmosysDiv, Object.assign({ osysName: "ConversionCanvasStepsList.inner", flexColCenteredFilled: true, innerRef: provided.innerRef, style: { maxWidth: 760 } }, provided.droppableProps),
                react_1.default.createElement(react_loops_1.For, { of: sortedSteps, ifEmpty: react_1.default.createElement(react_2.OsmosysUndesiredState, { message: "No steps", description: "Add your first conversion step by selecting one from the top toolbar", level: "info" }) }, (step, meta) => {
                    const metaInfo = constants_1.CONVERSION_STEP_META[step.type];
                    const destroy = () => {
                        const newSteps = [...draft.steps];
                        newSteps.splice(meta.index, 1);
                        dispatchCanvasAction({
                            data: {
                                draft: Object.assign(Object.assign({}, draft), { steps: newSteps }),
                            },
                            type: 'state',
                        });
                    };
                    if (!metaInfo) {
                        return (react_1.default.createElement(reactstrap_1.Alert, { color: "warning" },
                            react_1.default.createElement(react_2.OsmosysDiv, { flexRowCenteredFilled: true },
                                react_1.default.createElement(react_2.OsmosysDiv, { flexColCenteredFilled: true, marginRight: true },
                                    react_1.default.createElement("p", { className: "lead m-0" },
                                        "Conversion #",
                                        meta.index + 1,
                                        " is corrupted.")),
                                react_1.default.createElement(react_2.OsmosysDiv, { flexColCentered: true },
                                    react_1.default.createElement(react_2.OsmosysButton, { osysName: "deleteConversionStep", osysIcon: "trash", onClick: destroy, iconStyle: "regular", color: "warning" }, "Remove step")))));
                    }
                    return (react_1.default.createElement(ConversionStepCanvas_1.ConversionStepCanvas, { key: step.id || step.localId || meta.index, data: step, meta: metaInfo, position: meta, onDestroy: () => {
                            destroy();
                        }, moveUp: () => {
                            reorder(step.order, step.order - 1);
                        }, moveDown: () => {
                            reorder(step.order, step.order + 1);
                        }, onChange: newStepData => {
                            const newStepsArr = [...sortedSteps];
                            newStepsArr[meta.index] = Object.assign(Object.assign({}, newStepsArr[meta.index]), newStepData);
                            dispatchCanvasAction({
                                data: {
                                    draft: Object.assign(Object.assign({}, draft), { steps: newStepsArr }),
                                },
                                type: 'state',
                            });
                        } }));
                }),
                provided.placeholder))))));
};
//# sourceMappingURL=index.js.map